import { fetchPreferredServiceTimes as fetchPreferredServiceTimesRequest } from 'src/services/client';
import { IServiceRequestPreferredServiceTime } from 'src/services/api/ServiceRequest/apiContracts';

export interface UsePreferredServiceTimesAPIReturn {
  fetchPreferredServiceTimes: (
    serviceRequestId: string
  ) => Promise<IServiceRequestPreferredServiceTime[]>;
}

const isOkResponse = (response: any): boolean =>
  response.ok || response.status === 200;

export const usePreferredServiceTimesAPI =
  (): UsePreferredServiceTimesAPIReturn => {
    const fetchPreferredServiceTimes = async (
      serviceRequestId: string
    ): Promise<IServiceRequestPreferredServiceTime[]> => {
      try {
        const response: any =
          await fetchPreferredServiceTimesRequest(serviceRequestId);

        if (!isOkResponse(response)) {
          throw new Error(
            `Failed to fetch preferred service times: ${response.status}`
          );
        }

        const payload: any = await response.json();
        const preferredServiceTimes: IServiceRequestPreferredServiceTime[] =
          payload?.data ?? [];

        return preferredServiceTimes;
      } catch (err: any) {
        console.error(
          'usePreferredServiceTimesAPI fetchPreferredServiceTimes failed:',
          err
        );

        return [];
      }
    };

    return { fetchPreferredServiceTimes };
  };
